import { Tooltip } from "@mui/material";
import { DarkMode, LightMode } from "@mui/icons-material";
import { ISSwitch, isIconStyle } from "../ISSwitch";
import { useTranslation } from "react-i18next"
import { useThemeContext } from "../../theme/ThemeContext";

export const DarkModeSwitch = () => {
    const { theme, darkModeEnabled, setDarkModeEnabled} = useThemeContext()
    const { t } = useTranslation("others")

    const handleToggle = () => {
        setDarkModeEnabled(!darkModeEnabled)
    }
    
    return <Tooltip title={darkModeEnabled ? t(`lightThemeMode`) : t(`darkThemeMode`) }>
        <ISSwitch
            checked={darkModeEnabled}
            id={'darkmode'}
            icon={<LightMode sx={isIconStyle(theme)}/>}
            checkedIcon={<DarkMode sx={isIconStyle(theme)}/>}
            onChange={handleToggle}/>
        </Tooltip>
}
